import { defaultValues } from './const'
import { EmployeeLoginFormVO } from './type'

export const generateDefaultValues = (): EmployeeLoginFormVO => {
  return {
    ...defaultValues,
  }
}
